import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isEditableField'
})

export class IsEditableFieldPipe implements PipeTransform {
    public transform(field: string, editableFields: string[]): boolean {
        if(!editableFields.length){
            return true;
        }
        return editableFields.includes(field);
    }
}
